'use client'

import { useTranslations } from 'next-intl'

import { SheetContent, SheetHeader, SheetTitle } from '../../../../../../../../components/Sheet'

interface Props {
  children: React.ReactNode
  title?: string
  reset: () => void
}

const FilterSheetContent = ({ children, title, reset }: Props) => {
  const t = useTranslations('discover-sport-city')
  return (
    <SheetContent side="bottom" className="h-[70vh] bg-white">
      <SheetHeader className="relative mb-3 flex flex-row items-end justify-center">
        <button className="absolute left-0 underline" onClick={reset}>
          {t('reset-filters')}
        </button>
        <SheetTitle className="m-0 text-lg font-medium">{title || t('filters')}</SheetTitle>
      </SheetHeader>
      <div className="h-full overflow-y-scroll pb-10">{children}</div>
    </SheetContent>
  )
}
export default FilterSheetContent
